import { render, staticRenderFns } from "./DiscountPlanList.vue?vue&type=template&id=40cc51ab&scoped=true&"
import script from "./DiscountPlanList.vue?vue&type=script&lang=js&"
export * from "./DiscountPlanList.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPlanList.vue?vue&type=style&index=0&id=40cc51ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cc51ab",
  null
  
)

export default component.exports